import {
    AppointmentsModel
} from "one-card-appointments-table";

import {
    AppointmentData
} from 'one-model-local';

import { formatIso, getday } from 'one-util-date';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the 
 * Appointments Component
 * @param response has the backend 
 * appointment response
 * @param context has settings etc..
 */
//ADPAC-426
function sortFunction(a: AppointmentData, b: AppointmentData) {
    const dateA = new Date(a.date).getTime();
    const dateB = new Date(b.date).getTime();
    return dateA > dateB ? 1 : -1;
}
const formatdatestring=(dt:any)=>{
    const dateTime = new Date(dt);

    // Extract UTC components
    const year = dateTime.getUTCFullYear();
    const month = dateTime.getUTCMonth() + 1; // Month is zero-indexed, so add 1
    const day = dateTime.getUTCDate();
    let hours = dateTime.getUTCHours();
    let minutes: any = dateTime.getUTCMinutes();
    let seconds = dateTime.getUTCSeconds();

let ampm = hours >= 12 ? 'PM' : 'AM';

// Convert hours from 24-hour format to 12-hour format
hours = hours % 12;
hours = hours ? hours : 12; // the hour '0' should be '12' in 12-hour format

// Pad minutes with leading zeros if less than 10
minutes = minutes < 10 ? '0' + minutes : minutes;

// Construct the time string in 12-hour format
let timeString = hours + ':' + minutes + ' ' + ampm;
// Format the date and time as needed
const formattedDate = `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}-${year}`;
const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
return [formattedDate,formattedTime,timeString]
}
const visit_Type=[{key:"New Patient Ambulatory Visit",value:"99999998"},
    {key:"Follow Up Ambulatory Visit",value:"99999997"},
    {key:"Pre Admission Assessment",value:"99999995"},
    {key:"Ambulatory Well Child Visit",value:"99999994"}
]
let count=0

export const TransformResponse = (response: any, context: any, patientId: string) => {
    /**
     * @param result contains the transformed response
     */
    let result: AppointmentsModel = {};
    let dataarray: any = [];
    const { settings } = context ? context:"";
    const {uisettings:{dateformat}} = settings ? settings:{uisettings:""};
    const { settings:{appointment_config:{filterAppointments}}} = context;
    
//     const visit_filter=(code:any)=>{
//         let visit:any
//           visit_Type.forEach(vt=>{
//             if(code){
//             if(vt.value===code){
//              visit=vt.key
//             }
//         }
//         else{
//             visit=''
//         }
//           })
//           return visit
//    }
const visit_filter=(text:any)=>{
    let visit=""
    if(text){
        visit=text+""
    }
      return visit
}
    if (response && response.length > 0) {
       response?.map((ele: any, index:number) => {

        ele.entry?.map((ele:any,index:number)=>{

            let presentdate: number = new Date().getTime();
            let ddate: string = ele?.resource?.start ? formatdatestring(ele?.resource?.start)[0]  : "";
            let dtime: string = ele?.resource?.start ? formatdatestring(ele?.resource?.start)[1]  : "";
            let apptdate: number = new Date(ddate.concat(" ").concat(dtime)).getTime();

            let data: AppointmentData = {
                key: "",
                date: "",
                department: "",
                departmentId: "",
                appointmentTime: "",
                provider: "",
                providerId: "",
                status: "",
                visitType: "",
                visitTypeID: "",
                appointmentType: "",
                appointmentDuration: "",
                patientId: "",
                patientName: "",
                patientIDType: "",
                contactID: "",
                contactIDType: "",
                day: "",
                AppointmentNotes:"",
                ArrivalTime:""
            };
            data.key = index.toString();
            if (presentdate <= apptdate && ele?.resource?.status === "booked") {
                count ++
                data.appointmentType = "future";
            }
            if (presentdate > apptdate ) {
                data.appointmentType = "past";
            }
            if(ele?.resource?.status === "cancelled") {
                data.appointmentType = "canceled";
            }
            if(ele?.resource?.status === "noshow") {
                data.appointmentType = "noshows"
            }
            if (ele?.resource?.participant && ele?.resource?.participant?.length > 0) {
                let participantArray=ele.resource.participant;
                participantArray.map((pt:any)=>{
                    if(pt["actor"].DepartmentID){
                        data.departmentId=pt["actor"].DepartmentID
                        data.department=pt["actor"].DepartmentName
                    }
                    if(pt["actor"].ProviderID){
                        data.providerId=pt["actor"].ProviderID
                        data.provider=pt["actor"].ProviderName
                    }
                    if(pt["actor"].PatientID){
                        data.patientId=pt["actor"].PatientID
                        data.patientName=pt["actor"].PatientName
                    }
                })
            }
            data.date = ele?.resource?.start ? formatdatestring(ele?.resource?.start)[0] : "";
            data.day = ele?.resource?.start ? getday(formatdatestring(ele?.resource?.start)[0]) : "";
            data.status = ele?.resource?.status?ele?.resource?.status:""
            // data.visitType = visit_filter(ele?.resource?.serviceType?.[0]?.coding?.[0]?.code || '');
            data.visitType = visit_filter(ele?.resource?.serviceType?.[0]?.text);
            data.appointmentTime = formatdatestring(ele?.resource?.start)[2];
            data.apptID=ele?.resource?.id ? ele?.resource?.id : "";
            dataarray.push(data);
            //ADPAC-426
            dataarray.sort(sortFunction);
        });
        });

        result['data'] = dataarray;
    }
    return result;


}